
import React from "react";
import { useGetAllProjectByOrganizationQuery } from "../../api/projectApiSlice";
import FilterByProjectPresentation from "../../presentation/filter.by.project.presentation/FilterByProjectPresentation";
import { FilterProjectContainerProps } from "../../types/types";
const FilterByProjectContainer: React.FC<FilterProjectContainerProps> = ({
  organizationID,
  onSelectProject,
  filterdBy,
  selectedDefault
}) => {
  const {
    data: projects,
   
    isSuccess,
  } = useGetAllProjectByOrganizationQuery({ organizationId: organizationID! });

  const selectProjectValue = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (e.target.value !== 'All') {
      const project = projects?.entities[e.target.value]
      onSelectProject(project!)
    } else {
      onSelectProject(null)
    }
  }

  return (
    <>
      {isSuccess && (
        <FilterByProjectPresentation
          projects={projects}
          onSelectProject={selectProjectValue}
          projectTypeFilter={filterdBy}
          selectedDefault={selectedDefault}
        />
      )}
    </>
  )
}

export default FilterByProjectContainer
